import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { ReactTagManager } from 'react-gtm-ts';
import { useGlobal } from 'contexts/globalContext';
import { PageInfo } from './PageInfo';

interface PageMissingProps {
	withRedirect?: boolean;
	debug?: string;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const PageMissing = ({ withRedirect, debug }: PageMissingProps) => {
	const { pathname } = useLocation();
	const { t } = useTranslation();
	const { prevPathname } = useGlobal();

	useEffect(() => {
		ReactTagManager.action({
			event: 'page_error',
			page_error_url: pathname,
			page_error_previouspage: prevPathname,
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<PageInfo
			message={pathname === '/no-org-found' ? t('misc.registerOrgMissing') : t('misc.missingPage')}
			debug={debug}
		/>
	);
};

export default PageMissing;
